import React from 'react';

export default props => (
    <div className="form-check">
        <input type="radio" id={props.value} className="form-check-input" name="choice" {...props}/>
        <label htmlFor={props.value} className="form-check-label">{props.value}</label>
    </div>                   
);
